@import (reference) '../../../constants/spacing.module.less';

.fulfillment-plan-header {
  justify-content: space-between;
  align-items: center;
  gap: @space-8;
}

.drag-overlay {
  opacity: 0.9;
}
